function ReturnTimelineMessage() {
    return (
        <div className='font-urbanist-regular border border-[#EAEAEA] rounded-lg px-4 py-3 flex flex-col gap-3'>
            <h1 className='font-semibold text-base text-[#666666]'>Return Timeline</h1>
        
            <p className='font-medium text-base text-[#121212]'>
                The product is being returned to the pickup address. We will provide tracking details once it has been rescheduled.
            </p>
        </div>
    );
}

export default ReturnTimelineMessage;
